export default __webpack_public_path__ + "static/web20240625-932611c0db30fc75605865e0e205f94d.png";